module.exports = __webpack_public_path__ + "img/postgresql-icon.7c6cf29f.svg";